import React, { useState, useEffect } from "react";
import { getRequest, postRequest } from "../Common/Utils.js";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import BootstrapTable from "react-bootstrap-table-next";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

const TableComponent = ({ selectRow2, dataChecked }) => {
  const [Productdata, setProductdata] = useState([]);
  const [loader, setLoader] = useState(false);
  const [sort, setsort] = React.useState("name");
  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState(dataChecked);

  // console.log(dataChecked);

  const limit = 10;
  const fetchUserlist = async (page = 0) => {
    setLoader(true);
    const payload = {
      limit: sizePerPageOrg,
      page: currentPage,
      sortField: '',
      sortOrder: "desc",
    };

    if (searchText) {
      payload.search = searchText;
    }

    const response = await postRequest(`user/list`, payload);
    const data = response?.data;
    const updatedData = data.list.map(item => {
      const isChecked = Array.isArray(dataChecked) && 
        dataChecked.some(checked => checked._id === item._id); 
      return { ...item, dataChecked: isChecked };
    });
    console.log(updatedData);
    setTotalPage(data.count);
    setCurrentFPage(data.page);
    setProductdata(updatedData);
    setLoader(false);
  };

  function iconFormatter(cellContent, row) {
    return (
      <React.Fragment>
        <div className="d-flex">
          {/* <button
            type="button"
            className="btn btn-danger"
            onClick={() => selectRow2(row, row._id, row.title)}
          >
            <i class="fal fa-plus  fs-5"></i>
          </button> */}
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => selectRow2(row, row._id, row.title)}
          >
            <i class="fal fa-plus  fs-5"></i>
          </button>
        </div>
      </React.Fragment>
    );
  }

  const handleCheckboxChange = (row, isChecked) => {
    setSelectedRows((prev) => {
      if (isChecked) {
        // Add the user to selectedRows if not already present
        const isAlreadySelected = prev.some((selectedRow) => selectedRow?._id === row?._id);
        if (!isAlreadySelected) {
          return [...prev, row];
        }
        return prev;
      } else {
        // Remove the user from selectedRows if unchecked
        return prev.filter((selectedRow) => selectedRow?._id !== row?._id);
      }
    });
  
    // Update dataChecked in Productdata
    setProductdata((prevData) =>
      prevData.map((item) =>
        item._id === row._id ? { ...item, dataChecked: isChecked } : item
      )
    );
  };
  
  const initializeCheckedRows = () => {
    setProductdata((prevData) =>
      prevData.map((item) => ({
        ...item,
        dataChecked: selectedRows.some((selectedRow) => selectedRow?._id === item?._id),
      }))
    );
  };
  
  // Sync Productdata with selectedRows when modal is opened
  useEffect(() => {
    initializeCheckedRows();
  }, [selectedRows]);

  const checkboxFormatter = (cellContent, row) => {
    return (
      <>
        <input
          checked={row?.dataChecked || false} 
          style={{ height: 20, width: 35, cursor: "pointer" }}
          type="checkbox"
          onChange={(e) => handleCheckboxChange(row, e.target.checked)}
        />
      </>
    );
  };

  useEffect(() => {
    fetchUserlist();
  }, [currentPage]);

  useEffect(() => {
    fetchUserlist();
  }, [sizePerPageOrg, sort]);

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
      }
    }
    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  const defaultSorted = [
    {
      dataField: "_id",
      order: "asc",
    },
  ];

  function ImgLogoFormatter(cellContent, row) {
    return (
      <>
        <img src={row?.photo} alt="img" width={"50px"} />
      </>
    );
  }
  function fullNameFormatter(cellContent, row) {
    return (
      <>
        {row?.first_name}&nbsp;{row?.last_name}
      </>
    );
  }



  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },
    {
      text: "Select",
      formatter: checkboxFormatter,
      sort: false,
    },
    {
      // dataField: "images",
      text: "User Images",
      formatter: ImgLogoFormatter,
      sort: false,
    },
    {
      // dataField: "first_name",
      text: "User Name",
      formatter: fullNameFormatter,
      sort: false,
    },
    {
      dataField: "email",
      text: "Email Id",
      sort: false,
    },

    // {
    //   dataField: "select",
    //   text: "Select",
    //   formatter: iconFormatter,
    //   sort: false,
    // },
  ];

  const handleChange = (event) => {
    console.log("page value ", event.target.value);
    setSizePerPage(event.target.value);
  };
  const handlesorting = (event) => {
    setsort(event.target.value);
    console.log("sorting  value ", event.target.value);
  };
  const handleReload = () => {
    window.location.reload();
  };



  return (
    <>
      <React.Fragment>
        <Row>
          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={Productdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <div className="d-flex w-50">
                                    <label className="mb-0 text-label">
                                      Page <br />Size
                                    </label>

                                    <select
                                      value={sizePerPageOrg}
                                      onChange={handleChange}
                                      className="form-select"
                                      style={{ width: "20%" }}
                                    >
                                      <option value="10">10</option>
                                      <option value="20">20</option>
                                      <option value="50">50</option>
                                    </select>
                                  </div>
                                  <div className="w-50 text-end">
                                    <div className="d-flex g-3 justify-content-end">
                                      <input
                                        type="search"
                                        placeholder="Search"
                                        value={searchText}
                                        class="form-control"
                                        onChange={(e) =>
                                          setSearchText(e.target.value)
                                        }
                                        style={{ width: "50%" }}
                                      />
                                      <button
                                        onClick={() => {
                                          ProductManagment();
                                        }}
                                        type="button"
                                        className="btn btn-primary mx-2"
                                      >
                                        Search
                                      </button>
                                      {selectedRows?.length > 0 && 
                                      <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => selectRow2(selectedRows)}
                                      >
                                        <i class="fal fa-plus  fs-5"></i>
                                      </button> }
                                    </div>
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    </>
  );
};

const UserListModal = ({ show, dataChecked, closeModal, selectRow2, isActive }) => {
  return (
    <Modal
      isOpen={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered={true}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myLargeModalLabel">
          User List
        </h5>
        <button
          onClick={() => {
            closeModal();
          }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <TableComponent dataChecked={dataChecked} isActive={isActive} selectRow2={selectRow2} />
      </div>
    </Modal>
  );
};

export default UserListModal;
